export default __webpack_public_path__ + "static/media/shopify.96a05185.png";